import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import styles from './videoTeaser.module.scss'
import { DialogComponent } from '@syncfusion/ej2-react-popups'
import { lazy, Suspense, useRef, useState } from 'react'
import { useAppSelector } from '../../redux/_reduxHooks'

// TypeScript benötigt Typ-Importe für Lazy-Loaded Komponenten
const LazyCustomDialog = lazy(() => import('../shared/CustomDialog'))
const LazyDlgVideoView = lazy(() => import('./DlgVideoPreview'))

export const VideoTeaser = () => {
  const [videoId, setVideoId] = useState<string | null>(null)
  const [dialogOpen, setDialogOpen] = useState(false)
  let dlgVideoView = useRef<DialogComponent | null>(null)

  const webEventTopicData = useAppSelector((state) => state.web.selectedNwTopic)

  const handleOnClick = () => {
    // ToDo: echte Video ID einsetzen
    if(webEventTopicData?.teaserVideo){
      setVideoId(webEventTopicData?.teaserVideo)
      setDialogOpen(true)
    }
  }

  const closeDlgView = () => {
    dlgVideoView?.current?.hide()
    setVideoId('')
    setDialogOpen(false)
  }

  return (
    <>
      <div className={styles.teaser}>
        <ButtonComponent className={styles.btn} onClick={handleOnClick}>
          <div className={styles.overlay}>
            <div className={styles.playBtnOuter}>
              <span className={`${styles.playBtn} e-icons e-play`}></span>
            </div>
            <div className={styles.overlayText}>Kursvorschau ansehen</div>
            <div className={`${styles.imgBox} embed-responsive embed-responsive-16by9`}>
              <img className={`${styles.img} embed-responsive-item`} alt={'Video Teaser'} src={webEventTopicData?.teaserImage} />
            </div>
          </div>
        </ButtonComponent>
      </div>

      {dialogOpen && (
        <Suspense fallback={<></>}>
          <LazyCustomDialog
            hasOwnFooterBtns={true}
            options={{
              className: 'mw900',
              isModal: true,
              closeOnEscape: true,
              target: '#root',
              visible: dialogOpen,
              width: '80%',
              header: `Video Vorschau: ${webEventTopicData?.thmKurz}`,
              onClose: closeDlgView,
            }}
          >
            <LazyDlgVideoView closeDlg={closeDlgView} videoId={videoId} />
          </LazyCustomDialog>
        </Suspense>
      )}
    </>
  )
}
